import React, { Component } from 'react';

import {API_BASE_URL} from '../../constants'

import axios from 'axios'
import {getToken} from '../../storage'
import {NotificationManager} from 'react-notifications'

class AddTransportlabel extends Component {


  constructor(props) {
    super(props)
    this.addtransportlabel = this.addtransportlabel.bind(this)

    this.handleInputChange = this.handleInputChange.bind(this)

    this.modifyItemState = this.modifyItemState.bind(this)
    this.getTransportlabel = this.getTransportlabel.bind(this)
    this.deleteTransportlabel = this.deleteTransportlabel.bind(this)
    this.state = {transportlabel : {
      label_name:"way_bill_no",
      bill_no:"", lr_no:"", challan_no:"", vehicle_no:"", ship_by:"", transporter_name:"", transporter_id:"", transporter_gstin:""
    }}
  }

  componentDidMount() {
    if(typeof this.props.match !=="undefined" && typeof this.props.match.params.transportlabel_id !== "undefined") {
      this.setState({mode:'edit'})
      document.title = "Edit Transportlabel " + this.props.match.params.transportlabel_id
      this.getTransportlabel(this.props.match.params.transportlabel_id).then((response)=>{
        if(response.status===200) {
          this.setState({transportlabel: response.data.transportlabel, loading:false})

        }
      }).catch((err)=>{
        this.setState({loading:false})
      })
    }
    else if (typeof this.props.invoice !== "undefined"
              && typeof this.props.invoice.transportlabel !== "undefined"
               && this.props.invoice.transportlabel !== null) {
      this.setState({transportlabel: this.props.invoice.transportlabel})
    }

    else {
        this.setState({loading:false})
    }

  }

  getTransportlabel(transportlabel_id) {
    return axios({
      url: '/get_transportlabel/?id='+transportlabel_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  modifyItemState(name, value) {
    let transportlabel = this.state.transportlabel
    transportlabel[name] = value
    this.setState({transportlabel:transportlabel})
    console.log(name, value);
  }


  handleInputChange(e) {
    this.modifyItemState(e.target.name, e.target.value)
  }
  deleteTransportlabel() {

    axios({
      url: '/delete_transportlabel/',
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state.transportlabel
    }).then((response)=> {
      if(response.status === 200) {
          NotificationManager.success("Deleted Transportlabel successfully")
        setTimeout(()=>{
          this.props.history.push("/transportlabels/")
        }, 700)
      }
    }).catch((err)=> {
      console.log(err);
    })
  }
  addtransportlabel(e) {
    this.setState({error_response_data: undefined})
    e.preventDefault()

    let apiurl
    if(this.state.mode ==="edit") {
      apiurl  = "/update_transportlabel/"
    }
    else {
      apiurl  = "/create_new_transportlabel/"
    }




    axios({
      baseURL: API_BASE_URL,
      url:apiurl,
      method:"POST",
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data:this.state.transportlabel
    }).then((response)=>{

      this.setState({transportlabel:response.data.transportlabel, submitting:false})
      if(typeof this.props.onAddCallback !== "undefined") {
      this.props.onAddCallback(response.data.transportlabel)
      }
      else {

        if(this.state.mode==="edit") {
          NotificationManager.success("Updated Transportlabel successfully")
        }
        else {
          NotificationManager.success("Created Transportlabel successfully")
        }

        setTimeout(()=>{

          this.props.history.push("/transportlabels/")
        }, 700)
      }


    }).catch(err=>{

      if(typeof err.response !== "undefined" && typeof err.response.data !== "undefined") {
        this.setState({error_response_data:err.response.data})
      }

    })
  }


  render() {

    let error_response_data = this.state.error_response_data
    let errors
    let ctransportlabel_error, stransportlabel_error, itransportlabel_error
    if(typeof error_response_data !== "undefined") {
      errors = error_response_data.errors
      console.log(errors);

    }


    let transportlabel = this.state.transportlabel

    if(typeof transportlabel === "undefined" || transportlabel === null) {
      transportlabel = {
        label_name:"",
        bill_no:"", lr_no:"", challan_no:"", vehicle_no:"", ship_by:"", transporter_name:"", transporter_id:"", transporter_gstin:""
      }
    }


    let pageHeader, deleteTransportlabelBtn
    if(this.state.mode === "edit") {
      deleteTransportlabelBtn = <button className="btn btn-danger" onClick={this.deleteTransportlabel}>Delete Transportlabel</button>
      pageHeader = <h3>{"Edit Transportlabel  " + transportlabel.primary_transportlabel}</h3>
    }
    else {
      pageHeader =  <h3 >Create New Transportlabel</h3>
    }

    return (
      <div>
      <section className="medium">
            {pageHeader}
            <ul className="list-inline">

              <li className="pull-right">{deleteTransportlabelBtn}</li>
            </ul>
      </section>
          <div className="">
              <div className="row">
                <div className="col-sm-12">


                    <div className="form-group">
                      <label htmlFor="label_name">Label Type</label>
                        <select className="form-control" name="label_name" onChange={this.handleInputChange} value={transportlabel.label_name}>
                        <option value="way_bill_no" selected>Way Bill No</option>
                        <option value="e_sugam_no">E-Sugam No</option>
                        <option value="eway_bill_no">E-Way Bill No</option>
                        </select>

                    </div>
                    <div className="form-group">
                      <label htmlFor="bill_no">Bill No.</label>
                        <input type="text" name="bill_no" className="form-control"
                           onChange={this.handleInputChange} value={transportlabel.bill_no} />
                    </div>
                    <div className="form-group">
                      <label htmlFor="lr_no">LR. No.</label>
                        <input type="text" name="lr_no" className="form-control"
                           onChange={this.handleInputChange} value={transportlabel.lr_no} />
                    </div>
                    <div className="form-group">
                      <label htmlFor="challan_no">challan No.</label>
                        <input type="text" name="challan_no" className="form-control"
                           onChange={this.handleInputChange} value={transportlabel.challan_no} />
                    </div>
                    <div className="form-group">
                      <label htmlFor="vehicle_no">Vehicle No.</label>
                        <input type="text" name="vehicle_no" className="form-control"
                           onChange={this.handleInputChange} value={transportlabel.vehicle_no} />
                    </div>
                    <div className="form-group">
                      <label htmlFor="ship_by">Ship By</label>
                        <input type="text" name="ship_by" className="form-control"
                           onChange={this.handleInputChange} value={transportlabel.ship_by} />
                    </div>
                    <div className="form-group">
                      <label htmlFor="transporter_name">Transporter Name</label>
                        <input type="text" name="transporter_name" className="form-control"
                           onChange={this.handleInputChange} value={transportlabel.transporter_name} />
                    </div>
                    <div className="form-group">
                      <label htmlFor="transporter_id">Transporter ID</label>
                        <input type="text" name="transporter_id" className="form-control"
                           onChange={this.handleInputChange} value={transportlabel.transporter_id} />
                    </div>
                    <div className="form-group">
                      <label htmlFor="transporter_gstin">Transporter GSTIN</label>
                        <input type="text" name="transporter_gstin" className="form-control"
                           onChange={this.handleInputChange} value={transportlabel.transporter_gstin} />
                    </div>

                    <span className="text-danger">{ctransportlabel_error}{stransportlabel_error}{itransportlabel_error}</span>
                    <div className="form-group">
                      <input type="submit" className="btn btn-info btn-block" value="Submit" onClick={this.addtransportlabel}/>
                    </div>

                </div>
              </div>
          </div>


      </div>
    )
  }
}

export default AddTransportlabel



// WEBPACK FOOTER //
// ./src/components/transportlabel/addtransportlabel.js